<ziro-select [fieldId]="'subscriptionName'"></ziro-select>
<ziro-text [fieldId]="'label'"></ziro-text>
